module.exports = __webpack_public_path__ + "img/theme16.25f2d6b5.png";